import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import mustache from 'mustache';
import stores from '../../models/index.model';
import queryString from 'query-string';
import { 
  Grid, 
  Button, 
  Typography,
  TextField,
  MenuItem,
  InputAdornment 
} from '@material-ui/core';
import { 
  KeyboardArrowLeft, 
  KeyboardArrowRight,
  Search 
} from '@material-ui/icons';
import 'react-table/react-table.css';
import './PaginatedTable.style.scss';
import { withTheme } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import Carousel from '../Carousel/Carousel.component';
import { DataCard } from '../Card/Card.component';
import FreeGoodManualAction from '../ActionButtons/transactionBatchFreeGoodManualAction';
import UpdateOverallPatientDetails from '../ActionButtons/updateOverallPatientDetails';
import ChasCardApproval from '../ActionButtons/chasCardApproval';
import ExportTableAction from '../ActionButtons/exportTable';
import AddHCPAction from '../ActionButtons/addHCP';
import SendPrefilledLink from '../ActionButtons/sendPrefilledLink';
import UploadManualForm from '../ActionButtons/uploadManualForm';
import UploadUtilizationForm from '../ActionButtons/uploadUtilizationForm';
import ApproveAffordabilityScheme from '../ActionButtons/affordabilitySchemeApprove';
import RejectAffordabilityScheme from '../ActionButtons/affordabilitySchemeReject';

// I cant import
import TransactionCodeFreeGoodApproveButton from '../ActionButtons/updateFreeGoodDeliveryStatus.jsx';
import BpDeliveryButton from '../ActionButtons/sanofi-my/bpDelivery.jsx';
import OptOutButton from '../ActionButtons/sanofi-my/optoutButton.jsx';
import BlacklistButton from '../ActionButtons/sanofi-my/blacklistButton.jsx';
import TransactionBatchPurchaseApprove from '../../components/ActionButtons/transactionBatchPurchaseApprove.jsx';
import TransactionBatchPurchaseDisapprove from '../../components/ActionButtons/transactionBatchPurchaseDisapprove.jsx';
import {
  TRANSACTIONS_CONSTANT,
  PROGRAMS_CONSTANT,
  REPORTING_CONSTANT,
} from '../../constants/common';
import { remove, values, includes, isEmpty, startsWith, reject } from 'lodash';
import UpdateTransactionButton from '../ActionButtons/sanofi-my/updateTransactionButton';
import VoidTransactionButton from '../ActionButtons/common-buttons/voidTransactionButton';
import UpdateLineItem from '../ActionButtons/updateLineItem';
import FreeGoodConfirmation from '../ActionButtons/transactionBatchFreeGoodConfirmation';
import EnrolledPharmaciesSelectPrograms from '../ActionButtons/EnrolledPharmaciesSelectPrograms';
import AddPatientAction from '../ActionButtons/addPatient';
import SendPatientTermsConditionsAction from '../ActionButtons/sendPatientTermsConditions';
import PreApprovalScheme from '../ActionButtons/preApprovalScheme';
import VoidLineItem from '../ActionButtons/voidLineItem';
import PatientRegistrationApproval from '../ActionButtons/patientRegistrationApproval';
import UpdateAppointmentDetails from '../ActionButtons/appointment/updateAppointmentDetails';
import AddAppointmentAction from '../ActionButtons/appointment/addAppointment';
import AddApplicationAction from '../ActionButtons/AddApplication';
import AddDosesAction from '../ActionButtons/Dose/AddDoses';
import FundingApplicationManagement from '../ActionButtons/FundingApplicationManagement';
import ActionDropdown from '../ActionButtons/actionDropdown';
import ValidateTransaction from '../ActionButtons/validateTransaction';
import UpdateDoseDetails from '../ActionButtons/Dose/updateDoseDetails';
import Collapsible from 'react-collapsible';
import AddEducationalReferenceAction from '../ActionButtons/educationalReferences/addEducationalReferences';
import UpadteEducationalReference from '../ActionButtons/educationalReferences/updateEducationalReference';
import CancelPatient from '../ActionButtons/cancelPatient';
import UpdateVoucherRedeemedDate from '../ActionButtons/updateVoucherRedeemedDate';
import PatientOrderApproval from '../ActionButtons/patientOrderApproval';
import PatientRegistrationApprovalWithTier from '../ActionButtons/patientRegistrationApprovalWithTier';
import TransactionBatchApproval from '../ActionButtons/TransactionBatchApproval';
import TransactionCodeApproval from '../ActionButtons/TransactionCodeApproval';
import ResendSelfDeclarationLink from '../ActionButtons/resendSelfDeclarationLink';
import actionButtons from '../../components/ActionButtons/index.actions.js';
import UpdateImage from '../ActionButtons/sybrava-my/updateImage';
import LgsUpdateLineItem from '../ActionButtons/lgs/updateLineItem';
import TransactionBatchorCodeApproval from '../ActionButtons/TransactionBatchorCodeApproval';
import PatientAssignLoadingDose from '../ActionButtons/AssignLoadingDose';
class ReactSimpleTable extends React.Component {
  state = {
    columns: [],
    searchText: '',
    searchColumn: 'all',
    searchableColumns: []
  };

  constructor(props) {
    // See: https ://reactjs.org/docs/legacy-context.html
    super(props);

    this._handleClickBlackList = this._handleClickBlackList.bind(this);
    this._handleClickBpDeliveryYes = this._handleClickBpDeliveryYes.bind(this);
    this._handleClickBpDeliveryNo = this._handleClickBpDeliveryNo.bind(this);
    this._handleClickOptOut = this._handleClickOptOut.bind(this);
    this._handleUpdateTransactionBatch = this._handleUpdateTransactionBatch.bind(this);
    this._handleVoidTransactionBatch = this._handleVoidTransactionBatch.bind(this);
  }

  componentDidMount() {
    let columnsTemp = null;

    const { columns, match, data } = this.props;
    const { connect_program_id: program_id, page_key } = match.params;
    const medkakiProgramIDList = values(PROGRAMS_CONSTANT.PROGRAM_ID.MEDKAKI);
    const isMedkaki = includes(medkakiProgramIDList, program_id);

    if (
      !isEmpty(data) &&
      data[0].transaction_type ===
        TRANSACTIONS_CONSTANT.TRANSACTION_TYPE.REDEEM &&
      isMedkaki &&
      page_key === REPORTING_CONSTANT.PAGE_KEY.TRANSACTION_DETAIL
    ) {
      remove(columns, { accessor: 'free_good_quantity' });
    }

    columnsTemp = rewriteSpecialColumns({
      columns,
      // propsColumns,
      program_id,
      onClickBlackList: this._handleClickBlackList,
      onClickBpDeliveryYes: this._handleClickBpDeliveryYes,
      onClickBpDeliveryNo: this._handleClickBpDeliveryNo,
      onClickOptOut: this._handleClickOptOut,
      onUpdateTransactionBatch: this._handleUpdateTransactionBatch,
      onVoidTransactionBatch: this._handleVoidTransactionBatch,
      imBtnVisibility: this.props.btnVisiblity,
    });
    // SET universal minWidth and maxWidth for columns

    const searchableColumns = [
      { value: 'all', label: 'All Columns' },
      ...columnsTemp
        .filter(col => col.accessor && (col.isSearchEnable || col.isSearchEnable === undefined))
        .map(col => ({
          value: col.accessor,
          label: col.Header || col.accessor,
          placeholder: col.searchPlaceholder || `Search ${col.Header || col.accessor}`
        }))
    ];

    this.setState({ 
      columns: columnsTemp,
      searchableColumns 
    });
  }

  _replaceText(text, params) {
    return mustache.render(text, params);
  }

  /**
   * On click black list action button event handler.
   *
   * @param {ID} userId The user id to be black listed.
   * @returns {Void}
   */
  async _handleClickBlackList({ user_id }) {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      await onChange({ user_id }, 'blacklist');
    }
  }

  /**
   * On click bp delivered action button event handler.
   *
   * @param {ID} userId The user id to be marked as bp delivered.
   * @returns {Void}
   */
  async _handleClickBpDeliveryYes({ user_id }) {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      await onChange({ user_id }, 'bpDeliveryDelivered');
    }
  }

  /**
   * On click bp not delivered action button event handler.
   *
   * @param {ID} userId The user id to be marked as bp not delivered.
   * @returns {Void}
   */
  async _handleClickBpDeliveryNo({ user_id }) {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      await onChange({ user_id }, 'bpDeliveryNotDelivered');
    }
  }

  /**
   * On click opt out action button event handler.
   *
   * @param {ID} userId The user id to be opted out.
   * @returns {Void}
   */
  async _handleClickOptOut({ user_id }) {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      await onChange({ user_id }, 'optOut');
    }
  }

  /**
   * On update transaction batch event handler.
   *
   * @returns {Void}
   */
  async _handleUpdateTransactionBatch() {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      await onChange({}, '');
    }
  }

  async _handleVoidTransactionBatch() {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      await onChange({}, '');
    }
  }

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSearchColumnChange = (e) => {
    this.setState({ searchColumn: e.target.value });
  };

  filterData = () => {
    const { data } = this.props;
    const { searchText, searchColumn, columns } = this.state;
    
    if (!searchText) return data;

    return data.filter(row => {
      if (searchColumn === 'all') {
        return columns.some(column => {
          if (!column.accessor || column.isSearchEnable === false) return false;
          const value = row[column.accessor];
          return value && value.toString().toLowerCase().includes(searchText.toLowerCase());
        });
      }
      
      const value = row[searchColumn];
      return value && value.toString().toLowerCase().includes(searchText.toLowerCase());
    });
  };

  pagination = () => {
    const params = queryString.parse(this.props.history.location.search);
    let currentPage = this.props.currentPage || params.page;
    if (
      currentPage < 1 ||
      currentPage > this.props.totalPages ||
      isNaN(currentPage)
    )
      currentPage = 1;

    return (
      <DataCard
        style={{ background: '#8b1b3f', height: '100%' }}
        // onExport={() => this._openExportModal()}
        // dataCount={this.props.patientStore.approvedPatients.count}
      >
        <Grid container spacing={3}>
          <Grid item xs={4} container justify="flex-end">
            <Grid item xs={6}>
              <Button
                fullWidth
                size="large"
                color="primary"
                variant="contained"
                onClick={this._onPrevious}
                disabled={(currentPage || 1) <= 1 ? true : false}
              >
                <KeyboardArrowLeft style={{ marginRight: 6 }} />
                Previous
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={4}>
            <div>
              Page {currentPage || 1} of {this.props.totalPages}
            </div>
          </Grid>
          <Grid item xs={4} container justify="flex-start">
            <Grid item xs={6}>
              <Button
                fullWidth
                size="large"
                color="primary"
                variant="contained"
                onClick={this._onNext}
                disabled={
                  (currentPage || 1) >= this.props.totalPages ? true : false
                }
              >
                Next
                <KeyboardArrowRight style={{ marginLeft: 6 }} />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DataCard>
    );
  };

  _onNext = async () => {
    const { start_date, end_date } = this.props.filterStore.filters;
    const { pageIdentifier } = this.props;
    const params = queryString.parse(this.props.history.location.search);
    params.start_date && delete params.start_date;
    params.end_date && delete params.end_date;
    let currentPage =
      this.props.currentPage || params[pageIdentifier || 'page'];
    pageIdentifier && delete params[pageIdentifier];
    params.page && delete params.page;
    const stringParams = queryString.stringify(params);
    if (
      currentPage < 1 ||
      currentPage > this.props.totalPages ||
      isNaN(currentPage)
    )
      currentPage = 1;
    const page = parseInt(currentPage || 1, 10) + 1;
    this.props.history.push(
      `${this.props.history.location.pathname}?${stringParams}&${
        pageIdentifier || 'page'
      }=${page}&start_date=${start_date}&end_date=${end_date}`
    );
  };

  _onPrevious = async () => {
    const { start_date, end_date } = this.props.filterStore.filters;
    const { pageIdentifier } = this.props;
    const params = queryString.parse(this.props.history.location.search);
    params.start_date && delete params.start_date;
    params.end_date && delete params.end_date;
    let currentPage =
      this.props.currentPage || params[pageIdentifier || 'page'];
    pageIdentifier && delete params[pageIdentifier];
    params.page && delete params.page;
    const stringParams = queryString.stringify(params);
    if (
      currentPage < 1 ||
      currentPage > this.props.totalPages ||
      isNaN(currentPage)
    )
      currentPage = 1;
    const page = parseInt(currentPage || 1, 10) - 1;
    this.props.history.push(
      `${this.props.history.location.pathname}?${stringParams}&${
        pageIdentifier || 'page'
      }=${page}&start_date=${start_date}&end_date=${end_date}`
    );
  };

  render() {
    const {
      data = [],
      history,
      match,
      title,
      exportButton = false,
      searchBar = false,
      searchBarWithColumnSelection = false,
      addHCPButton = false,
      addPatientButton = false,
      addAppointmentButton = false,
      addApplicationButton = false,
      addDosesButton = false,
      addEducationalReferenceButton = false,
      addActionButton = null
    } = this.props;
    
    const { 
      columns,
      searchText,
      searchColumn,
      searchableColumns 
    } = this.state;
    
 const filteredData = this.filterData();
    let dateFilter = '';
    const params = queryString.parse(this.props.history.location.search);
    const start_date = params.start_date;
    const end_date = params.end_date;
    if (params && start_date && end_date) {
      dateFilter = `&start_date=${start_date}&end_date=${end_date}`;
    }
    
    const defaultPageSize = match.params.connect_program_id.includes('pfizer-hk') ? (data.length > 0 ? 25 : 0) : (data.length > 0 ? 10 : 0);
  // const { columns, match, data } = this.props;
    const { connect_program_id: program_id, page_key } = match.params;


    const currentSearchColumn = searchableColumns.find(col => col.value === searchColumn);
    const searchPlaceholder = currentSearchColumn 
      ? currentSearchColumn.placeholder 
      : 'Search...';
      
    const ActionButtonComponent = addActionButton ? actionButtons[addActionButton] : null;

    return (
    <DataCard title={title}>
        {
          addHCPButton && (
            <AddHCPAction data={{ ...this.props }}></AddHCPAction>
          )
        }
        {
          addPatientButton && (
            <AddPatientAction data={{ ...this.props }}></AddPatientAction>
          )
        }
        {
          addAppointmentButton && (
            <AddAppointmentAction data={{ ...this.props }}></AddAppointmentAction>
          )
        }
        {
          addApplicationButton && (
            <AddApplicationAction data={{ ...this.props }}></AddApplicationAction>
          )
        }
         {
          addDosesButton && (
            <AddDosesAction data={{ ...this.props }}></AddDosesAction>
          )
        }
        {
          addEducationalReferenceButton && (
            <AddEducationalReferenceAction data={{ ...this.props }}></AddEducationalReferenceAction>
          )
        }
        {
          addActionButton && (
            <ActionButtonComponent data={{ ...this.props }}></ActionButtonComponent>
          )
        }
        {exportButton && (
          <ExportTableAction data={{ ...this.props, start_date, end_date }} />
        )}

      {/* Search Bar */}
       {searchBar && <div style={{ 
          display: 'flex', 
          gap: '16px', 
          marginBottom: '16px',
          alignItems: 'center'
        }}>
         {/*To enable column-based filtering (dropdown) */}
        { searchBarWithColumnSelection &&
         <TextField
            select
            value={searchColumn}
            onChange={this.handleSearchColumnChange}
            variant="outlined"
            size="small"
            style={{ minWidth: '200px' }}
          >
            {searchableColumns.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>}
          
          <TextField
            placeholder={searchPlaceholder || 'search...'}
            value={searchText}
            onChange={this.handleSearchChange}
            variant="outlined"
            size="small"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </div> }

        {/* Table */}
        <ReactTable
          data={filteredData}
          columns={columns}
          filterable={false}
          sortable={false}
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]).match(new RegExp(filter.value, 'i'))
          }
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                style: {
                  opacity: rowInfo.original.deleted_at ? '0.4' : '1',
                  background: rowInfo.original.deleted_at ? 'gray' : 'white',
                },
              };
            } else {
              return {};
            }
          }}
          getTdProps={(state, rowInfo, column) => {
            return rowInfo?.original
              ? {
                  onClick: (e) => {
                    if (column.link) {
                      history.push(
                        '/' +
                          match.params.connect_program_id +
                          this._replaceText(column.link, rowInfo.original) +
                          dateFilter
                      );
                    }
                  },
                  style: column.link && {
                    // color: palette.primary.main,
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  },
                }
              : {};
          }}
          getTheadProps={() => {
            return {
              style: {
                backgroundColor:
                  window.programConfig.program_metadata.page_theme
                    ?.primary_color || '#d82819',
              },
            };
          }}
          defaultPageSize={defaultPageSize}
          NoDataComponent={() => {
            return (
              <Typography
                variant="h6"
                style={{ padding: '20px' }}
                align="center"
              >
                No rows found
              </Typography>
            );
          }}
          showPagination={!!data.length}
          showPageSizeOptions={false}
          // PaginationComponent={this.pagination}
          className="-highlight card"
        />
      </DataCard>
    );
  }
}

// REMATCH

export default withTheme(ReactSimpleTable);

const _getVaccineQuantity = (data) => {
  try {
    const receiptData = JSON.parse(data);
    const result = receiptData
      .map((data) => data.number_of_vaccines ?? 1)
      .reduce((acc, curr) => acc + curr, 0);

    return isNaN(result) ? 'N/A' : result;
  } catch (e) {
    return 'Error';
  }
};

const _getImageUrl = (data) => {
  let imageUrl = data;
  let isImageArray;
  let imageDetails;

  try {
    imageUrl = JSON.parse(data);
  } catch (e) {}

  if (imageUrl && Array.isArray(imageUrl) && imageUrl.length) {
    try {
      imageDetails = imageUrl.map((imgDetails) => {
        const urlPattern = /([\w\d_-]*)\.?[^\\\/]*$/i;
        let trackingId = null;
        if (imgDetails.image_url) {
          trackingId = imgDetails.image_url.match(urlPattern)[1];
        }
        if (imgDetails.webview_path) {
          trackingId = imgDetails.webview_path.match(urlPattern)[1];
        }

        return {
          dateUploaded: imgDetails.uploaded_date
            ? moment(imgDetails.uploaded_date).format('MM/DD/YYYY HH:mm')
            : null,
          trackingId,
        };
      });

      if (imageUrl && imageUrl[0].image_url) {
        imageUrl = imageUrl.map((image) => image.image_url);
      }
      if (imageUrl && imageUrl[0].webview_path) {
        imageUrl = imageUrl.map((image) => image.webview_path);
      }
    } catch (e) {
      console.log('Not an array of objects with image_url');
    }
    const isMultipleImages = imageUrl.length > 1;
    isImageArray = isMultipleImages;
    imageUrl = isMultipleImages ? imageUrl : imageUrl[0];
  } else if (Array.isArray(imageUrl) && imageUrl.length <= 0) {
    imageUrl = null;
  } else {
    isImageArray = false;
  }

  return { imageUrl, isImageArray, imageDetails };
};

/**
 * Create new and modified column properties based on `col_type`.
 *
 * @param {Object} param0 { columns, program_id, onClickBlackList, onClickBpDeliveryYes, onClickBpDeliveryNo, onClickOpOut }
 * @returns []
 */
function rewriteSpecialColumns({
  columns = [],
  program_id,
  onClickBlackList,
  onClickBpDeliveryYes,
  onClickBpDeliveryNo,
  onClickOptOut,
  onUpdateTransactionBatch,
  onVoidTransactionBatch,
  imBtnVisibility,
}) {
  let modifiedColumns = [];
  // Clone, prevent args mutations.
  const columnsCopy = [...columns];

  columnsCopy.forEach((column) => {
    if (column.col_type) {
      switch (column.col_type) {
        // VACCINE QUANTITY (for FLL program)
        case 'vaccine_quantity':
          column['Cell'] = (props) => {
            const data = props.original[column.accessor];
            return _getVaccineQuantity(data);
          };
          break;
        // IMAGE column type
        case 'image':
          column['Cell'] = (props) => {
            const data = props.original[column.accessor];
            const {
              imageUrl: imageURL,
              isImageArray,
              imageDetails,
            } = _getImageUrl(data);
          

            return imageURL ? (
              <Button
                disabled={imBtnVisibility}
                color="secondary"
                variant="contained"
                size="small"
                onClick={() =>
                  stores.dispatch.uiStore.showPopupModal({
                    title: props.column.Header && props.column.Header,
                    message: (
                      <div>
                        {isImageArray ? (
                          <div style={{ textAlign: 'center' }}>
                            <Carousel
                              images={imageURL}
                              imageDetails={imageDetails}
                            />
                            <span style={{ display: 'inline-block' }}>
                              Click particular image to enlarge
                            </span>
                          </div>
                        ) : <>
                          <img
                            style={{
                              objectFit: 'contain',
                              height: '240px',
                              width: '480px',
                              margin: '0 auto',
                              display: 'block',
                            }}
                            src={imageURL}
                          />
                          {
                            imageDetails && imageDetails[0].dateUploaded ? 
                            <div>Date Uploaded: {imageDetails[0].dateUploaded}</div> : 
                            <></>
                          }
                        </>
                        }
                      </div>
                    ),
                    actions: !isImageArray
                      ? [
                          {
                            label: 'Full View',
                            onClick: () => {
                              const link = document.createElement('a');
                              link.href = imageURL;
                              link.download = `${imageURL.split('/').pop()}`;
                              link.target = '_blank';
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            },
                          },
                        ]
                      : [],
                  })
                }
              >
                View Image
              </Button>
            ) : (
              '--'
            );
          };
          break;

          case 'image_with_edit':
          column['Cell'] = (props) => {
            const data = props.original[column.accessor];
            const patient_id = props.original['patient_id'];
            const receipt_obj = props.original['receipt_obj'];
            const {
              imageUrl: imageURL,
              isImageArray,
              imageDetails,
            } = _getImageUrl(data);

            return imageURL ? (
              <UpdateImage
                data={{
                  patient_id: patient_id,
                  imageURL,
                  program_id,
                  imageDetails,
                  isImageArray,
                  receipt_obj,
                }}
                title={props.column.Header}
                disabled={imBtnVisibility}
              />
            ) : (
              '--'
            );
          };
          break;


        // DATE column type
        case 'date':
          column['Cell'] = (props) => {
            const date = props.original[column.accessor];

            return date ? moment(date).format('MM/DD/YYYY HH:mm') : '--';
          };
          break;
        case 'date_no_time':
          column['Cell'] = (props) => {
            const date = props.original[column.accessor];
            return date ? moment(date).format('MM/DD/YYYY') : '--';
          };
          break;
          case 'file_link':
  column['Cell'] = (props) => {
    const url = props.original[column.accessor];
    return url ? (
      <a href={url} target="_blank" rel="noopener noreferrer">
       {url}
      </a>
    ) : '--';
  };
  break;
        // PARAGRAPH column type
        case 'paragraph':
          column['Cell'] = (props) => {
            const paragraph = props.original[column.accessor];
            return paragraph ? (
              <b
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  stores.dispatch.uiStore.showPopupModal({
                    title: props.column.Header && props.column.Header,
                    message: <span>{props.original[column.accessor]}</span>,
                    actions: [],
                  })
                }
              >
                {props.original[column.accessor]}
              </b>
            ) : (
              '--'
            );
          };
          break;
        // MULTILINE column type
        case 'multiline':
          column['Cell'] = (props) => (
            <span>
              {props.original[column.accessor] &&
                props.original[column.accessor].split(',').map((value) => {
                  return <div key={value}>{value}</div>;
                })}
            </span>
          );
          break;
        case 'vaxx_array':
          column['Cell'] = (props) => {
            const vaxxDateArray = JSON.parse(props.original[column.accessor]);
            const applicationType = props.original['patient_type'];
            return (
              <span>
                {vaxxDateArray &&
                  vaxxDateArray.map((value) => {
                    return (
                      <div key={value.nth_dose}>
                        {applicationType === 'baby_vaccination'
                          ? `${toOrdinal(value.nth_dose)} dose:`
                          : ''}
                        {value.date
                          ? ` ${moment(value.date).format('YYYY-MM-DD')}`
                          : ' -- '}{' '}
                      </div>
                    );
                  })}
              </span>
            );
          };
          break;
        // USER_ID column type
        case 'shorten_id':
        case 'user_id':
          column['Cell'] = (props) => {
            const value = props.original[column.accessor];
            if (startsWith(value, 'MYCARE')) {
              const match = value.match(/MYCARE[0]{0,}/);
              return value.split(match[0]);
            }

            return value.substring(0, 5);
          };
          break;
        case 'action':
          column['Cell'] = (props) => {
            const value = props.original[column.accessor];
            return (
              <TransactionCodeFreeGoodApproveButton
                data={{ transaction_code_id: value }}
              />
            );
          };
          break;
        case 'delivery_action':
            column['Cell'] = (props) => {
              const value = props.original[column.accessor];
              return (
                <TransactionCodeFreeGoodApproveButton
                  data={{ transaction_code_id: value }}
                />
              );
            };
            break;
        case 'bp_action':
          column['Cell'] = (props) => {
            const value = props.original[column.accessor];
            return (
              <BpDeliveryButton
                data={{ user_id: value }}
                onClickYes={onClickBpDeliveryYes}
                onClickNo={onClickBpDeliveryNo}
              />
            );
          };
          break;
        case 'transaction_approve_action':
          column['Cell'] = (props) => {
            const data = props.original;
            const value = data[column.accessor];
            const transaction_status = data.transaction_status;
            const transaction_type = data.transaction_type;
            return (
              <TransactionBatchPurchaseApprove
                data={{
                  transaction_batch_id: value,
                  user_id: props.original['patient_id'],
                  transaction_status,
                  transaction_type,
                }}
              />
            );
          };
          break;
        case 'transaction_disapprove_action':
          column['Cell'] = (props) => {
            const data = props.original;
            const value = data[column.accessor];
            const transaction_status = data.transaction_status;
            const transaction_type = data.transaction_type;

            return (
              <TransactionBatchPurchaseDisapprove
                data={{
                  transaction_batch_id: value,
                  user_id: props.original['patient_id'],
                  transaction_status,
                  transaction_type,
                }}
              />
            );
          };
          break;
        case 'optout_action':
          column['Cell'] = (props) => {
            const value = props.original[column.accessor];
            return (
              <OptOutButton data={{ user_id: value }} onClick={onClickOptOut} />
            );
          };
          break;
        case 'blacklist_action':
          column['Cell'] = (props) => {
            const value = props.original[column.accessor];
            return (
              <BlacklistButton
                data={{ user_id: value }}
                onClick={onClickBlackList}
              />
            );
          };
          break;
        case 'product_sku':
          column['Cell'] = (props) => {
            const productSkuId = props.original[column.accessor]
              ? props.original[column.accessor]
              : '--';
            const productSkuItems = productSkuId && productSkuId.split('_');
            const productSkuLabelFormatted =
              productSkuItems &&
              Array.isArray(productSkuItems) &&
              productSkuItems.length === 3
                ? `${
                    productSkuItems[0].charAt(0).toUpperCase() +
                    productSkuItems[0].slice(1)
                  } ${productSkuItems[1]}/${productSkuItems[2]}`
                : productSkuId;
            return productSkuLabelFormatted;
          };
          break;
        case 'free_good_manual_action':
          column['Cell'] = (props) => {
            const data = props.original;
            const transaction_batch_id = data.transaction_batch_id;
            const quantity = data.qty_unclaimed;
            const patient_id = data.patient_id;

            return (
              <FreeGoodManualAction
                data={{
                  transaction_batch_id,
                  quantity,
                  patient_id,
                  product_sku_id: data.sku_id,
                  program_id: program_id,
                }}
              ></FreeGoodManualAction>
            );
          };
          break;
          case 'free_good_confirmation_action':
            column['Cell'] = (props) => {
              const data = props.original;
              const transaction_code_id = data.transaction_code_id;
              const quantity = data.qty_unclaimed;
              const patient_id = data.patient_id;
              const patient_name = data.patient_name;
              const so_number = data.so_number;
  
              return (
                <FreeGoodConfirmation
                  data={{
                    transaction_code_id,
                    quantity,
                    patient_id,
                    program_id: program_id,
                    patient_name,
                    so_number: so_number
                  }}
                ></FreeGoodConfirmation>
              );
            };
            break;
        case 'send_tnc_action':
          column['Cell'] = (props) => {
            const data = props.original;
            const patient_id = data.patient_id;
            const status = data.status;
            const tnc_sent = data.tnc_sent;

            if (status === 'registered') {
              return (
                <SendPatientTermsConditionsAction
                  data={{
                    patient_id,
                    program_id: program_id,
                  }}
                ></SendPatientTermsConditionsAction>
              );
            }
            return <></>;
          };
          break;
        case 'update_transaction_batch_action':
          column['Cell'] = (props) => {
            const data = props.original;
            const transaction_batch_id = data[column.accessor];
            const transaction_status = data.transaction_status;
            const transaction_type = data.transaction_type;
            const user_id = props.original['patient_id'];

            return (
              <UpdateTransactionButton
                data={{
                  transaction_batch_id,
                  user_id,
                  transaction_status,
                  transaction_type,
                }}
                onUpdate={onUpdateTransactionBatch}
              />
            );
          };
          break;
        case 'update_line_item_action':
          column['Cell'] = (props) => {
            const data = props.original;
            const transaction_line_item_id = data.transaction_line_item_id;
            const meditag_number = data.meditags_used;
            const meditag_image_link = data.meditag_image;
            const patient_id = data.patient_id;

            return (
              <UpdateLineItem
                data={{
                  transaction_line_item_id,
                  meditag_number,
                  meditag_image_link,
                  program_id: program_id,
                  patient_id,
                }}
              ></UpdateLineItem>
            );
          };
          break;
             case 'enrolled_pharmacies_select_programs_action':
            column['Cell'] = (props) => {
              const data = props.original;
              return (
                <EnrolledPharmaciesSelectPrograms
                  data={{
                    data
                  }}
                ></EnrolledPharmaciesSelectPrograms>
              );
            };
         break;
        case 'age':
          column['Cell'] = (props) => {
            const data = props.original[column.accessor];
            const monthDiff = moment().diff(data, 'months');
            if (monthDiff >= 12) {
              return `${Math.floor(monthDiff / 12)} year(s) ${
                monthDiff % 12 !== 0 ? `${monthDiff % 12} month(s)` : ''
              }`;
            }
            return `${monthDiff} month(s)`;
          };
          break;
        case 'void_transaction_batch_action':
          column['Cell'] = (props) => {
            const data = props.original;
            const transaction_batch_id = data[column.accessor];

            return (
              <VoidTransactionButton
                data={{
                  transaction_batch_id,
                  program_id: program_id,
                }}
                onVoid={onVoidTransactionBatch}
              />
            );
          };
          break;
          case 'overall_patient_manual_action':
            column['Cell'] = (props) => {
              const data = props.original;
              const { chasis_card_status, chasis_card_url, email_approval_img, user_tier, patient_id } = data;

              return (
                <UpdateOverallPatientDetails
                  data={{
                    program_id: program_id,
                    chasis_card_status, chasis_card_url, email_approval_img, user_tier, patient_id
                  }}
                ></UpdateOverallPatientDetails>
              );
            };
            break;
          case 'overall_patient_chas_approval_action':
            column['Cell'] = (props) => {
              const data = props.original;
              const { chasis_card_status, chasis_card_url, email_approval_img, user_tier, patient_id } = data;

              return (
                <ChasCardApproval
                  data={{
                    program_id: program_id,
                    chasis_card_status, chasis_card_url, email_approval_img, user_tier, patient_id
                  }}
                ></ChasCardApproval>
              );
            };
          break;
          case 'send_prefilled_link':
          column['Cell'] = (props) => {
            const data = props.original;
            const { email, hcp_name, hcp_id, user_type  } = data;

            return (
              <SendPrefilledLink
                data={{
                  email, hcp_name, hcp_id, user_type 
                }}
              />
            );
          };
          break;
          case 'upload_manual_form_action':
            column['Cell'] = (props) => {
              const data = props.original;
  
              return (
                <UploadManualForm
                  data={data}
                />
              );
            };
          break;
          case 'loading_dosa_form_action':
            column['Cell'] = (props) => {
            const data = props.original;
            const { patient_id } = data;

            return (
              <PatientAssignLoadingDose
                data={{
                  ...data,
                  program_id: program_id,
                }}
              />
            );
          };
          break;
          case 'pre_approval_scheme_action':
            column['Cell'] = (props) => {
              const data = props.original;
  
              return (
                <PreApprovalScheme
                  data={data}
                />
              );
            };
          break;
          case 'upload_utilization_form_action':
            column['Cell'] = (props) => {
              const data = props.original;
  
              return (
                <UploadUtilizationForm
                  data={data}
                />
              );
            };
          break;
          case 'approve_affordability_scheme_action':
            column['Cell'] = (props) => {
              const data = props.original;
  
              return (
                <ApproveAffordabilityScheme
                  data={data}
                />
              );
            };
            break;
          case 'reject_affordability_scheme_action':
            column['Cell'] = (props) => {
              const data = props.original;
  
              return (
                <RejectAffordabilityScheme
                  data={data}
                />
              );
            };
            break;
          case 'void_line_item_action':
            column['Cell'] = (props) => {
              const data = props.original;
              const transaction_batch_id = data[column.accessor];
              const transaction_line_item_id = data.transaction_line_item_id;
  
              return (
                <VoidLineItem
                  data={{
                    ...data,
                    program_id: program_id,
                  }}
                />
              );
            };
          break;
           case 'update_Doses_actions':
            column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id} = data;

              return (
                <UpdateDoseDetails
                  data={{
                    ...data,
                    program_id: program_id,
                    patient_id,
                  }}
                />
              );
            };
          break;
             case 'update_Educatinal_Reference_actions':
            column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id} = data;

              return (
                <>
                <UpadteEducationalReference
                  data={{
                    ...data,
                    program_id: program_id,
                    patient_id,
                  }}
                />
                </>
              );
            };
          break;
          case 'patient_approval_action':
            column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id } = data;

              return (
                <PatientRegistrationApproval
                  data={{
                    ...data,
                    program_id: program_id,
                  }}
                />
              );
            };
            break;
          case 'update_appointment_action':
            column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id, appointment_id } = data;

              return (
                <UpdateAppointmentDetails
                  data={{
                    ...data,
                    program_id: program_id,
                    patient_id,
                    appointment_id
                  }}
                />
              );
            };
          break;
          case 'update_funding_application_actions':
            column['Cell'] = (props) => {
              const data = props.original;

              return (
              <FundingApplicationManagement 
              data={data} 
              />
              );
            };
          break;
          
          case 'free_box_action_dropdown':
            column['Cell'] = (props) => {
              const columnDetails = props.column;
              const actionDropdown = columnDetails.action_dropdown;
              const data = props.original;
              const { status, next_free_box_stage } = data;

              let valuesToOmit = ["free_box_processing", "free_box_at_pharmacy"];
              if (next_free_box_stage === "free_box_processing") {
                valuesToOmit = ["free_box_at_pharmacy", "validate_eligibility"];
              }
              if (next_free_box_stage === "free_box_at_pharmacy") {
                valuesToOmit = ["free_box_processing", "validate_eligibility"];
              }
              if (next_free_box_stage === "free_box_collected") {
                valuesToOmit = ["free_box_processing", "free_box_at_pharmacy", "validate_eligibility"];
              }

              const filteredActionDropdown = reject(actionDropdown, item => valuesToOmit.includes(item.value));

              if (status === "cancelled") {
                return <></>;
              }

              return (
                <ActionDropdown
                  data={{
                    ...data,
                    action_dropdown: filteredActionDropdown
                  }}
                ></ActionDropdown>
              )
            };
            break;
          case 'action_dropdown':
            column['Cell'] = (props) => {
              const columnDetails = props.column;
              const actionDropdown = columnDetails.action_dropdown;
              const data = props.original;
              const { status } = data;

              if (status === "cancelled") {
                return <></>;
              }

              const filteredActionDropdown = reject(actionDropdown, item => item.hide_on_status && item.hide_on_status.length && item.hide_on_status.includes(status));

              return (
                <ActionDropdown
                  data={{
                    ...data,
                    action_dropdown: filteredActionDropdown
                  }}
                ></ActionDropdown>
              )
            };
            break;
          case 'validate_transaction':
             column['Cell'] = (props) => {
              const data = props.original;

              return (
                <ValidateTransaction
                  data={{
                    ...data,
                  }}
                ></ValidateTransaction>
              )
            };
            break;
          case 'cancel_patient_action':
              column['Cell'] = (props) => {
                const data = props.original;
    
                return (
                  <CancelPatient
                    data={{
                      ...data,
                      program_id: program_id,
                    }}
                  />
                );
              };
            break;
          case 'update_redeem_voucherdate_action':
            column['Cell'] = (props) => {
              const data = props.original;
               return (
                  <UpdateVoucherRedeemedDate
                    data={{
                      ...data,
                      program_id: program_id,
                    }}
                  />
                );
              };
            break;
          case 'patient_approval_withtier_action':
             column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id } = data;

              return (
                <PatientRegistrationApprovalWithTier
                  data={{
                    ...data,
                    program_id: program_id,
                  }}
                />
              );
            };
            break;
          case 'order_approval_action':
             column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id } = data;

              return (
                <PatientOrderApproval
                  data={{
                    ...data,
                    program_id: program_id,
                  }}
                />
              );
            };
            break;
           case 'transaction_batch_approval_action':
             column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id } = data;

              return (
                <TransactionBatchApproval
                  data={{
                    ...data,
                    program_id: program_id,
                  }}
                />
              );
            };
            break;
            case 'transaction_code_approval_action':
             column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id } = data;

              return (
                <TransactionCodeApproval
                  data={{
                    ...data,
                    program_id: program_id,
                  }}
                />
              );
            };
            break;
          case 'transaction_batchorcode_approval_action':
              column['Cell'] = (props) => {
              const data = props.original;
              const { patient_id } = data;
              return (
                <TransactionBatchorCodeApproval
                  data={{
                    ...data,
                    program_id: program_id,
                  }}
                />
              );
              };
            break;
          case 'highlight':
            column['getProps'] = (state, rowInfo, column) => {
              const columnName = column.id;
              if (rowInfo) {
                const data = rowInfo.original;

                if (data && data[columnName] === 'yes') {
                  return {
                    style: {
                        background: '#FF2456',
                        color: '#ffffff',
                    },
                  };
                }

                return {
                  style: {
                    background: 'unset',
                  },
                };
              }

              return {
                style: {
                  background: 'unset',
                },
              };
            }

            break;
          case 'array_multiline':
            column['Cell'] = (props) => (
              <span>
                {props.original[column.accessor] &&
                  props.original[column.accessor].map((value) => {
                    return <div key={value}>{value}</div>;
                  })}
              </span>
            );
            break;
          case 'resend_self_declaration_link':
              column['Cell'] = (props) => {
                const data = props.original;
                const { program_id, self_declaration_id, status } = data;

                if (status === 'declared') {
                  return <></>;
                }
    
                return (
                  <ResendSelfDeclarationLink
                    data={{
                      program_id, self_declaration_id 
                    }}
                  />
                );
              };
            break;
          case 'lgs_update_line_item_action':
            column['Cell'] = (props) => {
              const data = props.original;
              return (
                <LgsUpdateLineItem
                  data={data}
                />
              );
            };
            break;
        default:
          break;
          
      }
    } else {
      //ADD -- IF VALUE IS NULL
      column['Cell'] = (props) => {
        const value = props.original[column.accessor];
        return value === null ? '--' : value;
      };
    }

    modifiedColumns.push({ ...column });
  });

  return modifiedColumns;
}

function toOrdinal(number) {
  return `${number}${
    ['st', 'nd', 'rd'][((((number + 90) % 100) - 10) % 10) - 1] || 'th'
  }`;
}

ReactSimpleTable.propTypes = {
  onChange: PropTypes.func,
};
